import { diff } from 'deep-object-diff'
import {
    get, map, pick, uniq
} from 'lodash'
import flat from 'flat'

const isFile = (v: any) => v instanceof File
export const getChangedKeys = (initialValues, values) => {
    const diffValues = diff(initialValues as Object, values as Object)
    const diffKeys = Object.keys(flat(diffValues))

    // deep-object-diff can't calculate diff of "File" type.
    // So we cover this case manually, and add it to "diffKeys"
    map(flat(values || {}), (value, key) => {
        if (isFile(value)) {
            if (get(initialValues, key) !== get(values, key)) {
                diffKeys.push(key)
            }
        }
    })
    return uniq(diffKeys
        .filter((key) => key !== 'undefined')
        // When diffValues is an array field, eg: performerIds: [12, 34]
        // the diffKeys will be like ["performerIds.0", "performerIds.1"] (using flat)
        // so we will replace to performerIds (remove .0 .1 ...)
        .map((key) => key.replace(/\.\d+$/, '')))
}

export const hasChanged = (initialValues, values) => (
    getChangedKeys(initialValues, values).length > 0
)

export const getChangedValues = (initialValues, values) => (
    pick(values, getChangedKeys(initialValues, values))
)

export const preventSubmitOnEnter = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
        keyEvent.preventDefault()
    }
}
